import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzVday80 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_VDAY_80: Record<
  Exclude<PageIdWoofzVday80, PageIdWoofzVday80.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_VDAY_80]: {
    id: PageId.SUBSCRIPTIONS_VDAY_80,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_VDAY_80]: {
    id: PageId.CHAT_UPSELL_VDAY_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_VDAY_80]: {
    id: PageId.UPSELL_VDAY_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_VDAY_80]: {
    id: PageId.DOWNLOAD_VDAY_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
